<ng-container *ngFor="let item of result">
    <ng-container [ngSwitch]="item.type">
        <ls-table *ngSwitchCase="'table'" [data]="item"></ls-table>
        <kendo-chart *ngSwitchCase="'barchart'" [style.height]="((item.series[0].length - 15) * 16 + 400) + 'px'">
            <kendo-chart-title [text]="item.title"></kendo-chart-title>
            <kendo-chart-category-axis>
              <kendo-chart-category-axis-item [categories]="item.categories">
              </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>
            <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [axisCrossingValue]="-15000" [labels]="labelSettings">
                </kendo-chart-value-axis-item>
            </kendo-chart-value-axis>
            <kendo-chart-series>
              <kendo-chart-series-item *ngFor="let series of item.series"
                type="bar"
                [gap]="1"
                [spacing]="1"
                [data]="series"
                [stack]="true"
              >
              </kendo-chart-series-item>
              <!-- <kendo-chart-series-item type="bar" [data]="[120, 67, 231, 196]">
              </kendo-chart-series-item>
              <kendo-chart-series-item type="bar" [data]="[45, 124, 189, 143]">
              </kendo-chart-series-item>
              <kendo-chart-series-item type="bar" [data]="[87, 154, 210, 215]">
              </kendo-chart-series-item> -->
            </kendo-chart-series>
          </kendo-chart>
          <kendo-chart *ngSwitchCase="'vwchart'" class="vw-chart" #vwChart>
            <kendo-chart-tooltip [shared]="true">
            </kendo-chart-tooltip>
            <kendo-chart-title [text]="item.title"></kendo-chart-title>
            <kendo-chart-legend position="bottom" orientation="horizontal" [labels]="{ font: 'Roboto' }">
            </kendo-chart-legend>
            <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [labels]="{rotation: 'auto', step: 2, font: 'Roboto'}"
                    [categories]="item.categories">
                </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>
            <kendo-chart-series>
                <kendo-chart-series-item type="line" *ngFor="let line of item.series; index as i" [data]="line.data"
                    [name]="item.legend[i]">
                    <!-- <kendo-chart-series-item-tooltip>
                    </kendo-chart-series-item-tooltip> -->
                </kendo-chart-series-item>
            </kendo-chart-series>
          </kendo-chart>
          <div *ngSwitchCase="'rating_set'">
            <h2>{{item.description}}</h2>
            <ls-table [data]="item.summary_table"></ls-table>
            <rev-linescale [lsData]="item.linescale"></rev-linescale>
            <kendo-chart [style.height]="((item.summary_chart.series[0].length) * 16 + 400) + 'px'">
              <kendo-chart-title [text]="item.summary_chart.title"></kendo-chart-title>
              <kendo-chart-legend position="bottom" orientation="horizontal" [labels]="{ font: 'Roboto' }" [spacing]="24">
              </kendo-chart-legend>
              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="item.summary_chart.categories">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>
              <kendo-chart-value-axis>
                  <kendo-chart-value-axis-item [axisCrossingValue]="-15000" [labels]="labelSettings">
                  </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>
              <kendo-chart-series>
                <kendo-chart-series-item *ngFor="let series of item.summary_chart.series; let i = index"
                  type="bar"
                  [gap]="1"
                  [spacing]="1"
                  [data]="series" [labels]="{ visible: true }"
                  [name]="item.summary_chart.legends[i]"
                >
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <ng-container *ngSwitchDefault>
            <span></span>
          </ng-container>
        <!-- <p *ngSwitchDefault>Other type</p> -->
    </ng-container>
</ng-container>